/* esm.sh - bezier-js@6.1.4 */
export * from "/*bezier-js@6.1.4/esnext/bezier-js.mjs";
